<p-table [value]="dataSource">
  <ng-template pTemplate="header">
    <tr [class]="'table__header--' + company | lowercase">
      <th>{{ columnLabels.product }}</th>
      <th [style]="{ width: priceColumnWidth }">{{ columnLabels.price }}</th>
      <th>{{ columnLabels.notes }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data>
    <tr>
      <td>{{ data.name }}</td>
      <td>{{ data.price ?? '-' }}</td>
      <td><div *ngFor="let addInfo of getAdditionalInfoList(data.additionalInfo)" [innerHTML]="addInfo"></div></td>
    </tr>
  </ng-template>
</p-table>
